import React from "react";
import { Link } from "react-router-dom";
import { useGetEmployeesQuery } from "store/employees/employeesApi";
import ArrowPng from "../assets/images/ArrowWork.png";

// cards alternate: normal, reverse-mobile, reverse, reverse + reverse-mobile
const cardClass = (index) => {
  const variants = [
    "people-card",
    "people-card reverse-mobile",
    "people-card reverse",
    "people-card reverse reverse-mobile",
  ];
  return variants[index % variants.length];
};

// some entries in the CMS are saved without a protocol
const linkedInUrl = (url) => {
  if (!url) return "";
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
};

function People() {
  const { data: employees, isLoading } = useGetEmployeesQuery();

  const peopleCards = employees?.data?.map((item, index) => {
    const { name, designation, linkedIn_url, headshot } = item?.attributes || {};
    const [firstName, ...lastName] = (name || "").trim().split(" ");
    const image = headshot?.data?.attributes;

    return (
      <Link
        to={linkedInUrl(linkedIn_url)}
        target="_blank"
        className={cardClass(index)}
        key={`people-card_${item?.id}`}
      >
        <div className="people-info">
          <p className="designation">{designation}</p>
          <h2 className="name">
            {firstName} <br /> {lastName.join(" ")}{" "}
            <span className="arrow-png">
              <img src={ArrowPng} alt="arrow" />
            </span>{" "}
          </h2>
        </div>
        <div className="img-wrap">
          <img src={image?.formats?.medium?.url || image?.url} alt={name} />
        </div>
      </Link>
    );
  });

  return (
    <div id="people">
      <div className="people-wrapper container">
        <div className="people-head-wrap">
          <h2 className="contact-heading">People</h2>
          <p>
            Ideas shape the world,
            <br /> our people shape ideas
          </p>
        </div>
        <div className="people-card-wrapper">
          {isLoading ? (
            <div className="spinner spinner-news">
              <span></span>
            </div>
          ) : (
            peopleCards
          )}
        </div>
      </div>
    </div>
  );
}

export default People;
